
import { useEffect, useRef } from 'react';

// Site key do widget "Controlly" no Cloudflare (pública; a secret fica só no backend)
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAFmLWc1kwzuK4P4_';
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let scriptPromise = null;
const loadScript = () => {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SCRIPT_SRC;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};

export const turnstileEnabled = Boolean(SITE_KEY);

// Widget do Cloudflare Turnstile (anti-robô). Sem REACT_APP_TURNSTILE_SITE_KEY não renderiza nada
// e o backend também pula a checagem. `resetKey` muda pra pedir um token novo (cada token vale uma vez).
export default function Turnstile({ onToken, resetKey = 0, theme = 'auto' }) {
  const ref = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let cancelado = false;
    loadScript().then(() => {
      if (cancelado || !ref.current || !window.turnstile) return;
      if (widgetId.current !== null) {
        window.turnstile.reset(widgetId.current);
        return;
      }
      widgetId.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        theme,
        language: 'pt-br',
        size: 'flexible',
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(null),
        'error-callback': () => onToken(null),
      });
    });
    return () => { cancelado = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  useEffect(() => () => {
    if (widgetId.current !== null && window.turnstile) window.turnstile.remove(widgetId.current);
  }, []);

  if (!SITE_KEY) return null;
  return <div ref={ref} className="min-h-[65px] w-full" />;
}
